import { render } from "./createPublicGroupComponent.vue?vue&type=template&id=4174c00d"
import script from "./createPublicGroupComponent.vue?vue&type=script&lang=js"
export * from "./createPublicGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__